import React from 'react'

import widgetService from 'live/services/widgets'
import { reactWidgetWrapper } from 'live/widgets/decorators/react'

import { rigFloorReducer } from '../rig-floor-editing-tool/RigFloorReducer'
import { RigFloorMessage, RigFloorState } from '../rig-floor-editing-tool/types'
import { withSuspenseWrapper } from '../../components/SuspenseWrapper'
import { riserType, riserName, riserDescription, RISER_KPI_OPTIONS } from '../constants'

// Reuses the same table/reducer/date-handling code as the Rig Floor Editing Tool
// (product-kpi-plugin-rig-floor:widget) - only the KPI universe differs, injected via
// mapConfigToProps below. See rig-floor-editing-tool/components/EditingTable.tsx and
// EditingTableRow.tsx, which accept kpiOptions as a prop for exactly this reason.
const WrapperRiserComponent = withSuspenseWrapper(
    React.lazy(() =>
        import('../rig-floor-editing-tool/components/EditingTable').then(module => ({
            default: module.KpiRigFloorEntry
        }))
    )
)

const RiserWidget = reactWidgetWrapper<RigFloorState, RigFloorMessage, DefaultChartConfigs>(
    WrapperRiserComponent,
    rigFloorReducer,
    {
        mapConfigToProps(configs) {
            return {
                widget: configs.widget,
                dashboardTheme: configs.dashboardContext?.theme,
                kpiOptions: RISER_KPI_OPTIONS
            }
        }
    }
)

widgetService.register({
    type: riserType,
    name: riserName,
    description: riserDescription,
    config: {
        color: 'red'
    },
    policies: {
        handleOwnMissingData: true
    },
    impl: RiserWidget
})
